export const SUBSCRIPTION_FEE = "SUBSCRIPTION_FEE";
